import { render } from "./TextComponent.vue?vue&type=template&id=5d571e7a&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"

import "./TextComponent.vue?vue&type=style&index=0&id=5d571e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d571e7a"]])

export default __exports__